import React from 'react'
import { DateRangePicker, Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';

export default function DateRangePickerDefault(props) {

	const { defaultValue, disabledDate, placement, size, placeholder } = props;

	const { dateRange, dateRangeChange } = props;
	const [startDate, endDate] = dateRange;


	const style = {
		padding: '0',
	};

	// safely parse start/end into Date objects only if present and valid
	const toDate = (v) => {
		if (!v) return null;
		const d = new Date(v);
		return isNaN(d.getTime()) ? null : d;
	}
	const parsedStart = toDate(startDate);
	const parsedEnd = toDate(endDate);
	// prefer provided defaultValue (if any), otherwise use parsedStart/parsedEnd only when both valid
	const pickerDefault = defaultValue ? defaultValue : (parsedStart && parsedEnd ? [parsedStart, parsedEnd] : undefined);

	const predefinedRanges = [
		{
			label: 'Today',
			value: [new Date(), new Date()],
			placement: 'left'
		},
		{
			label: 'Yesterday',
			value: [addDays(new Date(), -1), addDays(new Date(), -1)],
			placement: 'left'
		},
		{
			label: 'This week',
			value: [startOfWeek(new Date()), endOfWeek(new Date())],
			placement: 'left'
		},
		{
			label: 'Last 7 days',
			value: [subDays(new Date(), 6), new Date()],
			placement: 'left'
		},
		{
			label: 'Last 30 days',
			value: [subDays(new Date(), 29), new Date()],
			placement: 'left'
		},
		{
			label: 'This month',
			value: [startOfMonth(new Date()), new Date()],
			placement: 'left'
		},
		{
			label: 'Last month',
			value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
			placement: 'left'
		},
		{
			label: 'This year',
			value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
			placement: 'left'
		},
		{
			label: 'Last year',
			value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
			placement: 'left'
		},
		{
			label: 'All time',
			value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date()],
			placement: 'left'
		},
		{
			label: 'Clear',
			value: [null, null],
			placement: 'left'
		},
		{
			label: 'Last week',
			closeOverlay: false,
			value: value => {
				const [start = new Date()] = value || [];
				return [
					addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
					addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
				];
			},
			appearance: 'default'
		},
		{
			label: 'Next week',
			closeOverlay: false,
			value: value => {
				const [start = new Date()] = value || [];
				return [
					addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
					addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
				];
			},
			appearance: 'default'
		}
	];

	return (
		<DateRangePicker
			ranges={predefinedRanges}
			size={size || "md"}
			appearance="subtle"
			placeholder={placeholder || "Select start and end date"}
			className="form-control"
			character=" - "
			format='dd/MM/yyyy'
			style={style}
			placement={placement}
			defaultValue={pickerDefault}
			disabledDate={disabledDate}
			startdate={startDate}
			enddate={endDate}
			onChange={(update) => {
				dateRangeChange(update);
			}}
			cleanable={true}
		/>
	)
}

